import { makeVar } from "@apollo/client";
import { KEY_USER_INFO } from "_constants";

const initConfig = JSON.parse(window.localStorage.getItem(KEY_USER_INFO));
export const varUserInfo = makeVar(initConfig);
